import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../services/api';
import { LIST_CLASS_TYPE_REQUEST } from '../../actions';
import {
  listClassTypeSuccess,
  listClassTypeError,
} from './actions';

function* listClassType() {
  try {
    const response = yield call(api.get, 'classes-types');
    yield put(listClassTypeSuccess(response.data.data));
  } catch (error) {
    yield put(listClassTypeError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_CLASS_TYPE_REQUEST, listClassType),
  ]);
}
